// KWANKGM04060_借入申込同意不同意（受付完了）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import ContentInquiryFinalBody from './ContentInquiryFinalBody';
import MypageReturn from '../../molecules/MypageReturn';

interface Props {
  reception_cd: string;
  label: string;
  status_name: string;
}

const ContentInquiryFinal: React.FC<Props> = ({ label, status_name, reception_cd }) => {
  return (
    <>
      <TopArea
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={false}
        guide_text={''}
        display_status={false}
      />
      <ContentInquiryFinalBody />
      <MypageReturn is_staff={false} />
    </>
  );
};

export default ContentInquiryFinal;
